import './index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import HomePage from './pages/HomePage';
import KurzyPage from './pages/KurzyPage';
import PodminkyZpracovaniPage from './pages/PodminkyZpracovaniPage';
import ObchodniPodminkyPage from './pages/ObchodniPodminkyPage';
import NabidkaClickedPage from './pages/NabidkaClickedPage';
import PrihlaseniKurzPage from './pages/PrihlaseniKurzPage';
import NotFoundPage from './pages/404Page';
import { Analytics } from "@vercel/analytics/react"


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Analytics />
    <HelmetProvider>
      <BrowserRouter>
        <Routes>
          <Route path="*" element={<NotFoundPage />} />
          <Route path="/" element={<HomePage />} />
          <Route path="/kurzy" element={<KurzyPage />} />
          <Route path="/podminky_zpracovani" element={<PodminkyZpracovaniPage/>} />
          <Route path="/obchodni_podminky" element={<ObchodniPodminkyPage/>} />
          <Route path='/nabidka' element={<NabidkaClickedPage/>} />
          <Route path='/prihlaseni_kurz' element={<PrihlaseniKurzPage/>} />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);

